module.exports = __webpack_public_path__ + "static/media/construccion.d58badb4.jpeg";